import Footer from '@salesforce/retail-react-app/app/theme/components/project/footer'
Footer.baseStyle = {
    ...Footer.baseStyle,
    container: {
        width: '100%',
        background: 'gray.100',
        borderTop: '1px solid',
        borderColor: 'yellow.600'
    },
    subscribeHeading: {
        fontSize: {base: '27px', md: '26px'},
        color: 'black.300',
        fontWeight: '400',
        letterSpacing: '.005em'
    },
    subscribeField: {
        borderColor: 'gray.530 !important',
        border: '1px solid',
        paddingLeft: '15px',
        paddingTop: '10px',
        color: 'black.100'
    },
    content: {
        maxWidth: '100%',
        margin: {
            xl: '40px 90px 40px 90px',
            lg: '40px 45px 40px 45px',
            md: '40px 45px 40px 45px',
            base: '30px 0 30px 0'
        },
        sx: {
            'a:hover': {
                color: 'teal.600'
            }
        },
        padding: 0
    },
    contentPDP: {
        maxWidth: '100%',
        margin: {
            xl: '40px 90px 140px 90px',
            lg: '40px 45px 140px 45px',
            base: '40px 45px 130px 45px'
        },
        sx: {
            'a:hover': {
                color: 'teal.600'
            }
        },
        padding: 0
    }
}

export default Footer
